import React from 'react';
import Value from './Value';
import s from './ResponseDebugger.module.scss';
import PdfFill from './PdfFill';

type Field =
  & Parameters<typeof Value>[0]['field']
  & {
    id: string;
    key: string;
  };

type QuestionnaireResponse = {
  id: string;
  createdAt: string;
  updatedAt: string;
  value: unknown;
  source: string;
  field: Field;
  rowKey: string | null;
  listRowResponseId: string | null;
  submittedBy: {
    id: string;
    name: string | null;
  } | null;
  pdfFills: Array<Parameters<typeof PdfFill>[0]['pdfFill']>;
};

type Props = {
  response: QuestionnaireResponse;
};

const SingleResponse: React.FC<Props> = ({ response }) => (
  <div className={s.singleResponseWrapper}>
    <div><strong>Id:</strong> {response.id}</div>
    {response.listRowResponseId && (
      <div><strong>List Row Response Id:</strong> {response.listRowResponseId}</div>
    )}
    <div><strong>Row Key:</strong> {response.rowKey ?? 'N/A'}</div>
    <div><strong>Created At:</strong> {response.createdAt ? new Date(response.createdAt).toLocaleString() : 'N/A'}</div>
    <div><strong>Updated At:</strong> {response.updatedAt ? new Date(response.updatedAt).toLocaleString() : 'N/A'}</div>
    <div><strong>Submitted By:</strong> {response.submittedBy
      ? (response.submittedBy.name ?? response.submittedBy.id)
      : 'N/A'
    }</div>
    <div><strong>Field id:</strong> {response.field.id}</div>
    <div><strong>Field key:</strong> {response.field.key}</div>
    <div><strong>Field type:</strong> {response.field.type}</div>
    {response.rowKey && (
      <div><strong>Row Key:</strong>{response.rowKey}</div>
    )}
    <div>
      <strong>Value in DB:</strong>
      <Value
        field={response.field}
        value={response.value}
      />
    </div>
    <div><strong>Source:</strong> {response.source ?? 'N/A'}</div>
    <h3>PdfFills ({response.pdfFills.length})</h3>

    {response.pdfFills.map((pdfFill) => (
      <PdfFill key={pdfFill.id} pdfFill={pdfFill} />
    ))}
  </div>
);

export default SingleResponse;
